var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "speed-dial-demo" }, [
    _c(
      "div",
      [
        _c("h4", [_vm._v("默认设置")]),
        _c("fu-speed-dial", { attrs: { items: _vm.items } })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("h4", [_vm._v("item点击后不关闭")]),
        _c("fu-speed-dial", {
          attrs: {
            direction: "left",
            items: _vm.items,
            "item-click-close": false
          }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("h4", [_vm._v("点击空白处不关闭")]),
        _c("fu-speed-dial", {
          attrs: { items: _vm.items, "outside-close": false }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c(
          "h4",
          [
            _vm._v(" 手动开关 "),
            _c(
              "el-button",
              {
                staticClass: "fab-demo-manual",
                attrs: { size: "small" },
                on: { click: _vm.toggle }
              },
              [
                _vm.active
                  ? _c("span", [_vm._v("关闭")])
                  : _c("span", [_vm._v("打开")])
              ]
            )
          ],
          1
        ),
        _c("fu-speed-dial", {
          attrs: { items: _vm.items, manual: true },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }